import { Buffer } from 'buffer';

(globalThis as typeof globalThis & { Buffer?: typeof Buffer }).Buffer ??= Buffer;

import { provideZoneChangeDetection } from "@angular/core";
// /// <reference types="@angular/localize" />

// import { bootstrapApplication } from '@angular/platform-browser';
// import { AppComponent } from './app/app.component';
// import { provideAnimations } from '@angular/platform-browser/animations';
// import { provideRouter } from '@angular/router';
// import { routes } from './app/app.routes';
// // import { HttpClientModule } from '@angular/common/http';
// // import { AppRoutingModule } from './app/app-routing.module';

// bootstrapApplication(AppComponent, {
//   providers: [
//     provideAnimations()
//     // AppRoutingModule
//   ]
// }).catch(err => console.error(err));




import { bootstrapApplication, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { mergeApplicationConfig } from '@angular/core';
import { appConfig } from './app/app.config';
import { browserAppConfig } from './app/app.config.browser';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  ...mergeApplicationConfig(appConfig, browserAppConfig),
  providers: [
    provideZoneChangeDetection(),
    ...mergeApplicationConfig(appConfig, browserAppConfig).providers,
    provideClientHydration(withEventReplay()),
  ],
})
  .catch((err) => console.error(err));
